import React, { Component } from 'react';

interface IExpandableTextProps {
  text: string;
  textExpanded: string;
  textClassName: string;
  expandedTextClassName: string;
  maxTextLength: number;
  renderToggleButton: (args: {
    isExpanded: boolean;
    toggle: () => void;
  }) => React.ReactNode;
}

interface IExpandableTextState {
  isExpandable: boolean;
  isExpanded: boolean;
}

class ExpandableText extends Component<
  IExpandableTextProps,
  IExpandableTextState
> {
  constructor(props) {
    super(props);

    this.state = {
      isExpandable: undefined,
      isExpanded: undefined,
    };
  }

  static getDerivedStateFromProps(
    props: IExpandableTextProps,
    state: IExpandableTextState,
  ) {
    const isExpandable =
      !!props.text && props.text.length > props.maxTextLength;

    if (isExpandable !== state.isExpandable) {
      return {
        isExpandable,
        isExpanded: false,
      };
    }

    return null;
  }

  onToggle = () => {
    this.setState((state) => ({
      isExpanded: !state.isExpanded,
    }));
  };

  render() {
    const {
      text,
      textExpanded,
      renderToggleButton,
      textClassName,
      expandedTextClassName,
    } = this.props;
    const { isExpandable, isExpanded } = this.state;

    return (
      <>
        {isExpandable && !isExpanded ? (
          <p className={textClassName}>{text}</p>
        ) : (
          <p
            className={expandedTextClassName}
            dangerouslySetInnerHTML={{
              __html: textExpanded,
            }}
          />
        )}
        {isExpandable &&
          renderToggleButton({ isExpanded, toggle: this.onToggle })}
      </>
    );
  }
}

export default ExpandableText;
